import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [],
  template: `
    <footer class="footer">
      <div class="footer-content">
        <p class="footer-text">
          &copy; {{ currentYear }} RPW Dashboard. Todos los derechos reservados.
        </p>
        <nav class="footer-links">
          <button class="footer-link" (click)="onLinkClick('privacy')">Política de privacidad</button>
          <span class="footer-separator">&bull;</span>
          <button class="footer-link" (click)="onLinkClick('terms')">Términos del servicio</button>
          <span class="footer-separator">&bull;</span>
          <button class="footer-link" (click)="onLinkClick('contact')">Contacto</button>
        </nav>
      </div>
    </footer>
  `,
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  readonly currentYear = new Date().getFullYear();

  onLinkClick(_page: string): void {
    // Navigate command
  }
}
